'use strict';

var IdentityNoType = {
    NationalIdNo: 1, // 身分證字號
    NewUnifiedNo: 1 << 1, // 新式統一證號
    OldUnifiedNo: 1 << 2, // 舊式統一證號
    UnifiedBusinessNo: 1 << 3, // 統一編號
};
var KEY = 'EOAUTH.v1';
var currentClass = 'id';
var branchID = '8840';
var storedItem = localStorage.getItem(KEY);
function validID(idNumber) {
    if (idNumber.length === 8) {
        return checkIdNo(idNumber, IdentityNoType.UnifiedBusinessNo);
    } else if (idNumber.length === 10) {
        return checkIdNo(
            idNumber,
            IdentityNoType.NationalIdNo | IdentityNoType.NewUnifiedNo | IdentityNoType.OldUnifiedNo,
        );
    } else {
        return false;
    }
}

function checkIdNo(idNo, allowedType) {
    // 身分證第一碼(10-35)，3 個特例 (W:32、I:34、O:35)
    const capitals = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ];
    // 身分證第一碼(10-35)轉換後，十位數*1 + 個位數*9
    const capitalInts = [
        1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11, 20, 48, 29, 38, 47, 56, 65, 74, 83, 21, 3,
        12, 30,
    ];
    // 舊居留證第一碼(10-35)轉換後，十位數*1 + 個位數*9
    // 因檢查碼只要檢查是否為 10 的倍數，這裡直接作 [(十位數*1) % 10] + [(個位數*9) % 10]
    const unifiedNoFirstInts = [
        1, 10, 9, 8, 7, 6, 5, 4, 9, 3, 2, 2, 11, 10, 8, 9, 8, 7, 6, 5, 4, 3, 11, 3, 12, 10,
    ];
    // 舊居留證第二碼(10-35)轉換後，個位數*8
    // 因檢查碼只要檢查是否為 10 的倍數，這裡直接作 [(個位數*8) % 10]
    const unifiedNoSecondInts = [
        0, 8, 6, 4, 2, 0, 8, 6, 2, 4, 2, 0, 8, 6, 0, 4, 2, 0, 8, 6, 4, 2, 6, 0, 8, 4,
    ];
    const businessNoMultipliers = [1, 2, 1, 2, 1, 2, 4, 1];

    function validateNationalIdNo(reg) {
        if (!reg.test(idNo)) {
            return false;
        }

        const idNoCharArray = idNo.split('');
        let verifyNum = 0;

        // 基數 += 第 1 碼
        verifyNum += capitalInts[capitals.indexOf(idNoCharArray[0])];

        // 基數 += 第 2-9 碼相加
        for (let i = 1, j = 8; i < 9; i++, j--) {
            verifyNum += +idNoCharArray[i] * j;
        }

        // (10 - 基數之個位數) % 10
        verifyNum = (10 - (verifyNum % 10)) % 10;

        return verifyNum === +idNoCharArray[9];
    }

    function validateOldUnifiedNo() {
        const reg = new RegExp(/^[A-Z]{1}[A-D]{1}[0-9]{8}$/);

        if (!reg.test(idNo)) {
            return false;
        }

        const idNoCharArray = idNo.split('');
        let verifyNum = 0;

        // 基數 += 第 1 碼
        verifyNum += unifiedNoFirstInts[capitals.indexOf(idNoCharArray[0])];

        // 基數 += 第 2 碼
        verifyNum += unifiedNoSecondInts[capitals.indexOf(idNoCharArray[1])];

        // 基數 += 第 3-9 碼相加
        for (let i = 2, j = 7; i < 9; i++, j--) {
            verifyNum += +idNoCharArray[i] * j;
        }

        // (10 - 基數之個位數) % 10
        verifyNum = (10 - (verifyNum % 10)) % 10;

        return verifyNum === +idNoCharArray[9];
    }

    function validateUnifiedBussinessNo() {
        const reg = new RegExp(/^(?!11111111|00000000)[0-9]{8}$/);

        if (!reg.test(idNo)) {
            return false;
        }

        const idNoCharArray = idNo.split('');
        let verifyNum = 0;

        // 乘積的十位數與個位數總和
        for (let i = 0; i < 8; i++) {
            const product = +idNoCharArray[i] * businessNoMultipliers[i];
            const tens = product % 10;
            const ones = (product - tens) / 10;
            verifyNum += tens + ones;
        }

        return verifyNum % 5 === 0 || (+idNoCharArray[6] === 7 && (verifyNum + 1) % 5 === 0);
    }

    let isValid = false;

    allowedType =
        allowedType ||
        IdentityNoType.NationalIdNo |
        IdentityNoType.OldUnifiedNo |
        IdentityNoType.NewUnifiedNo |
        IdentityNoType.UnifiedBusinessNo;

    // 身分證字號
    if (IdentityNoType.NationalIdNo & allowedType) {
        isValid = validateNationalIdNo(new RegExp(/^[A-Z]{1}[1-2]{1}[0-9]{8}$/));
    }
    // 新式統一證號
    if (!isValid && IdentityNoType.NewUnifiedNo & allowedType) {
        isValid = validateNationalIdNo(new RegExp(/^[A-Z]{1}[89]{1}[0-9]{8}$/));
    }
    // 舊式統一證號
    if (!isValid && IdentityNoType.OldUnifiedNo & allowedType) {
        isValid = validateOldUnifiedNo();
    }
    // 統一編號
    if (!isValid && IdentityNoType.UnifiedBusinessNo & allowedType) {
        isValid = validateUnifiedBussinessNo();
    }

    return isValid;
}

function displayMessage(evt) {
    switch (evt.data.type) {
        case 'safearea-height': {
            document.documentElement.style.setProperty('--safe-top', `${evt.data.data}px`);
            break;
        }
    }
}

$(function () {
    window.isFlutterApp = function () {
        return (
            navigator.userAgent.includes('Fugle-App-Flutter') ||
            navigator.userAgent.includes('FugleTrade-App-Flutter')
        );
    };

    if (window.isFlutterApp()) {
        $('body').addClass('is-flutter');
    }

    if (window.addEventListener) {
        window.addEventListener('message', displayMessage, false);
    }
});
